import React, { useRef, useState, useEffect } from 'react';
import ReactToPrint from 'react-to-print';
import axios from 'axios'
import { BASE_URL_PREBID, TEST_URL_PREBID } from '../../config/axios';
import { useParams } from 'react-router-dom';
import { formattedDateLong } from '../Criticalissue/Date'
import numberToWords from 'number-to-words';
import { toast, ToastContainer } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import { formatCurrencyIndian, handleErrorToast } from '../custom';
import { Printer, UpdatePencilWhite, UpdatePencil } from '../AllSvg';
import { EditInvoiceRequest } from './ProjectDetailsPageComponents';

const PerformaInvoiceSlip = React.forwardRef((props, ref) => {


  const [invoiceData, setInvoiceData] = useState({
    "project": {},
    "client": {},
    "invoice": {},
  })

  let { id } = useParams();
  const [match, setMatch] = useState(false);
  const [word, setWord] = useState("");


  const getInvoiceData = async () => {
    try {
      const res = await axios.get(`${BASE_URL_PREBID}/project/invoicedetails/${id}/`);
      setInvoiceData(res.data)
      // console.log(numberToWords.toWords(res.data.invoice?.billamount), res.data.invoice?.billamount, 'words')
      setWord(numberToWords.toWords(res.data.invoice?.billamount))
      // console.log("useeefect")
      const firstTwoCharactersRGSTIN = res.data?.client?.gstin_number?.substring(0, 2);
      const firstTwoCharactersIGSTIN = invoiceGSTIN.substring(0, 2);

      if (firstTwoCharactersRGSTIN === firstTwoCharactersIGSTIN) {
        setMatch(true);
      }
    } catch (err) {
      handleErrorToast(err)
    }
  };
  const invoiceGSTIN = invoiceData.invoice.sub_company_detail?.company_gst;

  useEffect(() => {
    getInvoiceData(id);
  }, []);

  // useEffect(() => {

  //   console.log(invoiceData, 'words')
  //   setWord(numberToWords?.toWords(invoiceData?.invoice?.billamount))
  // }, [invoiceData])

  console.log("invoiceData?.invoice?.id")
  console.log(invoiceData?.invoice?.id)
  // console.log("invoiceData?.project_details?.id")
  // console.log(invoiceData?.project_details?.id)

  function isFirstTwoCharsSame(str1, str2) {
    if (typeof str1 !== 'string' || typeof str2 !== 'string') return false;

    const firstTwo1 = str1.slice(0, 2).toLowerCase();
    const firstTwo2 = str2.slice(0, 2).toLowerCase();

    return firstTwo1 === firstTwo2;
  }

  return (
    <div className="invoice-container" ref={ref}>
      <div className="invoice-container">
        <div className="invoice-header">
          <div className="invoice-header-left">
            <img
              src={invoiceData.invoice.sub_company_detail?.company_logo}
              alt="logo"
              className="invoice-logo"
            />
          </div>
          <div className="">
            <div className="company-name">{invoiceData.invoice.sub_company_detail?.company_name}</div>
            <div className="company-address" style={{ maxWidth: "250px" }}>
              {invoiceData.invoice.sub_company_detail?.company_address}
            </div>
            <div className="company-address" style={{ maxWidth: "250px" }}>
              {invoiceData.invoice.sub_company_detail?.contact_number}
            </div>
            <div className="company-address" style={{ maxWidth: "250px" }}>
              {invoiceData.invoice.sub_company_detail?.email}
            </div>
          </div>
        </div>
        <div className="invoice-title">PERFORMA INVOICE</div>

        <div className="invoice-divider "></div>
        <div className="section-header">
          <div className="">
            <div style={{ display: "flex ", alignItems: "center", justifyContent: "end" }}>
              <div className="section-title ">Performa Invoice Date :</div>

              <div className="performa-table-cell">{formattedDateLong(invoiceData.invoice?.billing_date)}</div>


            </div>
          </div>
        </div>
        <div className="details-section">
          <div style={{ width: "50%" }}>
            <div className="section-title">Recipient Details</div>
            <table className="performa-table">
              <tbody>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Name</td>
                  <td className="performa-table-cell performa-table-cell ">
                    {invoiceData.client.client_name}
                  </td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Address</td>
                  <td className="performa-table-cell performa-table-cell ">{invoiceData.client.address}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Email</td>
                  <td className="performa-table-cell performa-table-cell  ">{invoiceData.client.email}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Contact No.</td>
                  <td className="performa-table-cell performa-table-cell ">{invoiceData.client.contact_number}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">POS</td>
                  <td className="performa-table-cell performa-table-cell ">{invoiceData.client.pos}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">GSTIN</td>
                  <td className="performa-table-cell performa-table-cell ">{invoiceData.client.gstin_number}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Wo Number</td>
                  <td className="performa-table-cell performa-table-cell ">{invoiceData.project_details?.wono}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Wo date</td>
                  <td className="performa-table-cell performa-table-cell ">
                    {formattedDateLong(invoiceData.project_details?.wo_date)}
                  </td>
                </tr>

                <br />
              </tbody>
            </table>
          </div>

          <div style={{ width: "50%" }}>
            <div className="section-title">Performa Invoice Detail</div>
            <table className="performa-table">
              <tbody>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Performa Invoice no.</td>
                  <td className="performa-table-cell font-weight700 ">{invoiceData.invoice?.pi_invoice_number
                  }</td>
                </tr>

                <tr>
                  <td className="section-title font-weight500 invoice-td">Running Invoice</td>
                  <td className="performa-table-cell font-weight700 ">{invoiceData.invoice?.serial_number}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">CIPL Project no.</td>
                  <td className="performa-table-cell ">{invoiceData.project.prebid_prcode}</td>
                </tr>
                {/* <tr>
                  <td className="section-title font-weight500 ">PAN</td>
                  <td className="performa-table-cell ">{invoiceData.client.pan}</td>
                </tr> */}
                <tr>
                  <td className="section-title font-weight500 invoice-td">Bank Name</td>
                  <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.bank_name}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td ">Branch Name</td>
                  <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.branch_name === null ? '-' : invoiceData.invoice.sub_company_detail?.branch_name}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">Account No.</td>
                  <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.account_number}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">IFSC</td>
                  <td className="performa-table-cell ">{invoiceData.invoice.sub_company_detail?.ifsc_code}</td>
                </tr>
                <tr>
                  <td className="section-title font-weight500 invoice-td">GSTIN</td>
                  <td className="performa-table-cell ">{invoiceGSTIN}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="invoice-divider"></div>
        <tr className="project-name-section  " >
          <td style={{ display: "flex", gap: "10px", margin: "10px 0" }}>
            <th>Name of Work: <span style={{ fontWeight: "500" }}>{invoiceData.project.project_name}</span> <span>- Pre Tender Engineering Services</span></th>
            {/* <td>{invoiceData.project.project_name}- Pre Tender Engineering Services</td>
            <th>- Pre Tender Engineering Services</th> */}
          </td>
        </tr>

        <div className="invoice-body">
          <table className="performa-table">
            <thead>
              <tr className="performa-table-header">
                <th className="performa-table-cell column-small">Sn</th>
                <th className="performa-table-cell column-large">Project Particulars</th>
                <th className="performa-table-cell column-medium align-right">Work Order</th>
                <th className="performa-table-cell column-amount align-right">Rate %</th>
                <th className="performa-table-cell column-amount align-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <React.Fragment>
                <tr className="performa-table-row">
                  <td className="performa-table-cell column-small">{1}</td>
                  <td className="word-wrap-20vw column-large project-details">{invoiceData.invoice?.work_stages}</td>
                  <td className="performa-table-cell column-medium align-right">
                    {formatCurrencyIndian(invoiceData.project_details?.without_gst_amount)}
                  </td>
                  <td className="performa-table-cell column-amount">
                    {invoiceData.invoice?.bill_percentage}%
                    {/* <UpdateInvoiceStage invoiceId={invoiceData?.invoice?.id} projectDetailsId={invoiceData?.project_details?.id} workstages={invoiceData.invoice?.work_stages} getInvoice={getInvoiceData} /> */}
                  </td>
                  <td className="performa-table-cell-right column-amount performa-table-cell-center">
                    {formatCurrencyIndian(invoiceData.invoice?.wihoutgst_amount)}
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} className=""></td>
                </tr>
              </React.Fragment>

              <br />
              <tr>
                <td colSpan={5} className=""></td>
              </tr>
            </tbody>
          </table>

          <div className="invoice-divider"></div>


          <table className="performa-table">
            <tbody>
              <tr>
                <td colSpan={5} className=""></td>
              </tr>
              <tr>
                <td className="performa-table-cell column-small"></td>
                <td className="summary-label">
                  <b className='font-weight600'>Total Amount Before Tax</b>
                </td>
                <td className="performa-table-cell summary-value"></td>
                <td className="performa-table-cell-right column-medium"></td>
                <td className="performa-table-cell-right column-amount"></td>
                <td className="performa-table-cell-right column-amount">
                  <b className='font-weight600 text-black'>{formatCurrencyIndian(invoiceData.invoice?.wihoutgst_amount)}</b>
                </td>
              </tr>
              <tr className="performa-table-row">
                <td className="performa-table-cell performa-table-header column-small"></td>
                <td className="summary-label">
                  <b className='font-weight600'>Work Order Summary -</b>{" "}
                </td>
                <td className="performa-table-cell summary-value">
                  <b className='font-weight600 text-black'>Amount</b>{" "}
                </td>
                <td className="performa-table-cell-right column-medium">
                  <b className='font-weight600'>IGST</b>
                </td>
                <td className="performa-table-cell-right column-amount text-black">{!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '18%' : '0%'}</td>
                <td className="performa-table-cell column-amount">
                  {!isFirstTwoCharsSame ? '---' : formatCurrencyIndian(invoiceData.invoice?.gst_amount)}
                </td>
              </tr>
              <tr>
                <td className="performa-table-cell column-small"></td>
                <td className=" summary-label"><b className='font-weight600'>Total Value of Work Order</b></td>
                <td className="performa-table-cell summary-value">
                  {formatCurrencyIndian(invoiceData.project_details?.without_gst_amount)}
                </td>
                <td className="performa-table-cell-right column-medium">
                  <b className='font-weight600'>SGST </b>
                </td>
                <td className="performa-table-cell-right column-amount text-black">{!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '0%' : '9%'}</td>
                <td className="performa-table-cell column-amount">
                  {!isFirstTwoCharsSame ? formatCurrencyIndian(invoiceData.invoice?.gst_amount / 2) : '---'}
                </td>
              </tr>
              <tr>
                <td className="performa-table-cell column-small"></td>
                <td className=" summary-label"><b className='font-weight600'>Total Billing Up to Previous Invoice</b></td>
                <td className="performa-table-cell summary-value">
                  {invoiceData.total_billing_up_to_previous < 0 ? "-" : invoiceData.total_billing_up_to_previous}
                </td>
                <td className="performa-table-cell-right column-medium">
                  <b className='font-weight600'>CGST</b>
                </td>
                <td className="performa-table-cell-right column-amount text-black">{!isFirstTwoCharsSame(invoiceData.client.gstin_number, invoiceGSTIN) ? '0%' : '9%'}</td>
                <td className="performa-table-cell column-amount">
                  {!isFirstTwoCharsSame ? formatCurrencyIndian(invoiceData.invoice?.gst_amount / 2) : '---'}
                </td>
              </tr>
              <tr>
                <td className="performa-table-cell column-small"></td>
                <td className=" summary-label"><b className='font-weight600'>Total Billing in Current Invoice</b></td>
                <td className="performa-table-cell summary-value font-weight-normal">
                  {formatCurrencyIndian(invoiceData.invoice?.wihoutgst_amount)}
                </td>
                <td className="performa-table-cell-right column-medium">
                  <b className='font-weight600'>Total Tax</b>
                </td>
                <td className="performa-table-cell-right column-amount"></td>
                <td className="performa-table-cell column-amount">
                  {formatCurrencyIndian(invoiceData.invoice?.gst_amount)}
                </td>
              </tr>

              <tr>
                <td className="performa-table-cell column-small"></td>
                <td className=" summary-label">
                  <b className='font-weight600'>Balance to Bill</b>
                </td>
                <td className="performa-table-cell summary-value">
                  <b className='font-weight600 font-weight-normal'>{invoiceData.balance_to_bill}</b>
                </td>
                <td className="performa-table-cell-right column-medium"></td>
                <td className="performa-table-cell-right column-amount"></td>
                <td className="performa-table-cell-right column-amount"></td>
              </tr>
              <tr>
                <td className="performa-table-cell column-small"></td>
                <td className=" summary-label">
                  <b className='font-weight600'>Total Amount After Tax</b>
                </td>
                <td className="performa-table-cell summary-value"></td>
                <td className="performa-table-cell-right column-medium"></td>
                <td className="performa-table-cell-right column-amount"></td>
                <td className="performa-table-cell-right column-amount">
                  <b className='font-weight600 text-black'>{formatCurrencyIndian(invoiceData.invoice?.billamount)}</b>
                </td>
              </tr>

            </tbody>
          </table>

          <tr className="performa-table-row">
            <td className="performa-table-cell column-small"> </td>
            <td style={{ color: '#495057' }}>
              <b className='font-weight600' style={{ textTransform: "capitalize" }}>{word} Only</b>
            </td>
          </tr>
        </div>
        <div className="terms-section">
          <div>
            <th>Terms and Conditions:-</th>
            <h6 className="terms-item">1. Invoice is True and fair </h6>
            <h6 className="terms-item">2. All disputes belong to Haryana Jurisdiction </h6>
            <h6 className="terms-item">3. Payment Shall be made within 5 Date of Tax Invoice </h6>
            <h6 className="terms-item">4. We are Registered MSME Unit Vide No.- UDYAM-DL-11-0010217 </h6>
            <h6 className="terms-item">
              <b>5. This is Software generated Invoice no signature required</b>
            </h6>
          </div>
          {/* <div className='salaryslip-bottom-signature'>
            <th>For CivilMantra Infracon Pvt Ltd</th>
            <img src={"Signature"} alt='signature' className='slaryslip-bg-signature' />
            <th>AUTHORISED SIGNATURE</th>
          </div> */}
        </div>
      </div>
      <div className="print-background"></div>
    </div>
  );
});

const UpdateInvoiceDate = ({ getInvoice, i, invoiceId, projectDetailsId, workstages }) => {
  // let { id } = useParams();

  console.log("billing date ")

  console.log(`${i?.invoice?.id}`);

  //   ****************   Modal Section
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setFormData({ billing_date: i?.invoice?.billing_date, change_date: "yes" });
    getClientDetails();
  };
  const [loading, setLoading] = useState(false); //loading logic
  const [formData, setFormData] = useState({
    billing_date: "null",
    change_date: "yes",
  });
  const [errors, setErrors] = useState({});

  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      'billing_date'
    ];

    requiredFields.forEach(field => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };






  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (validateForm()) {
  //     const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
  //     try {
  //       let res = await axios.put(`${BASE_URL_PREBID}/project/invoiceUpdate/${i?.invoice?.id}/`, formData,)

  //       if (res.status === 200) {
  //         await getInvoice();
  //         handleClose();
  //       } else {
  //         alert(res);
  //       }
  //     } catch (err) {

  //       handleErrorToast(err, loadingToastId)
  //     } finally {
  //       setLoading(false); //loading logic
  //       toast.dismiss(loadingToastId);
  //     }
  //   } else {
  //     console.log('Form contains errors:', errors);
  //   }
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? 'green' : '',
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const [totalPercentage, setTotalPercentage] = useState(0);
  const [allWorkStages, setAllWorkStages] = useState([]);
  const [inputFields, setInputFields] = useState([{ workStages: '', percentage: '', project_detail: projectDetailsId }]);
  const [errorMessage, setErrorMessage] = useState("");




  const getClientDetails = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL_PREBID}/project/workstagesbyprojectDetail/${projectDetailsId}/`);
      setAllWorkStages(res.data)
      const stageNames = typeof workstages === "string"
        ? workstages.split(",").map(stage => stage.trim().toLowerCase())
        : [];
      const filteredStages = res.data.filter(stage =>
        stageNames.includes(stage.workStages.trim().toLowerCase())
      );

      const stagesWithCreatedAt = filteredStages.map(stage => ({
        ...stage,
        created_at: stage.created_at || new Date().toISOString(), // Fallback to current date if missing
        isSaved: true,
      }));

      setInputFields(
        stagesWithCreatedAt.length > 0
          ? stagesWithCreatedAt
          : [{ workStages: '', percentage: '', project_detail: projectDetailsId, isSaved: false, created_at: new Date().toISOString() }]
      );

      let total = 0;
      res.data.forEach(stage => {
        total += stage.percentage || 0;
      });
      setTotalPercentage(total);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveInputField = (index) => {
    const updatedFields = [...inputFields];
    updatedFields.splice(index, 1);
    setInputFields(updatedFields);
    recalculateTotalPercentage(updatedFields);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFields = [...inputFields];

    updatedFields[index][name] = value;
    setInputFields(updatedFields);

    const newTotal = recalculateTotalPercentage(updatedFields);

    const lastStage = updatedFields[updatedFields.length - 1];
    const extraStageExists = lastStage.workStages === "" || lastStage.percentage === "";

    if (newTotal < 100 && !extraStageExists && value !== "") {
      setInputFields([...updatedFields, { workStages: '', percentage: '', project_detail: projectDetailsId, isSaved: false, created_at: new Date().toISOString() }]);
    }

    if (newTotal >= 100 && updatedFields.length > 1 && updatedFields[updatedFields.length - 1].percentage === "") {
      const newFields = updatedFields.slice(0, -1);
      setInputFields(newFields);
      recalculateTotalPercentage(newFields);
    }
  };

  const recalculateTotalPercentage = (fields) => {
    let total = 0;
    // fields.forEach(field => {
    //   total += Number(field.percentage || 0);
    // });

    // Add percentages from fields
    fields.forEach(field => {
      total += Number(field.percentage || 0);
    });

    // Add percentages from allWorkStages excluding duplicates
    allWorkStages.forEach(stage => {
      const isDuplicate = fields.some(field => field.workStages === stage.workStages);
      if (!isDuplicate) {
        total += Number(stage.percentage || 0);
      }
    });

    setTotalPercentage(total);
    return total;
  };

  const validatePercentage = () => {
    if (totalPercentage > 100) {
      setErrorMessage(`Total percentage should not be greater than 100. Current value is ${totalPercentage}`);
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.change_date === "yes") {
      if (validateForm()) {
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
          let res = await axios.put(`${BASE_URL_PREBID}/project/invoiceUpdate/${i?.invoice?.id}/`, formData,)

          if (res.status === 200) {
            await getInvoice();
            handleClose();
          } else {
            alert(res);
          }
        } catch (err) {

          handleErrorToast(err, loadingToastId)
        } finally {
          setLoading(false); //loading logic
          toast.dismiss(loadingToastId);
        }
      } else {
        console.log('Form contains errors:', errors);
      }
    } else {
      if (validatePercentage()) {
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
          const res = await axios.put(`${BASE_URL_PREBID}/project/invoiceupdateview/${invoiceId}/`, inputFields, {
            headers: {
              'Content-Type': 'application/json',
              accept: "application/json",
            }
          });
          if (res.status === 200) {
            const updatedFields = inputFields.map(field => ({ ...field, isSaved: true }));
            setInputFields(updatedFields);
            await getClientDetails();
            await getInvoice();
            toast.success("Stages updated successfully!");
            handleClose();
          } else {
            toast.error("Error updating stages");
          }
        } catch (err) {
          handleErrorToast(err);
        } finally {
          setLoading(false);
          toast.dismiss(loadingToastId);
        }
      }
    }



  };







  return (
    <>

      {/* <button className='text-button' style={{ margin: "0 20px" }} onClick={handleShow}>
        <svg width="20" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 2L22 6M2 22L3.2764 17.3199C3.35968 17.0145 3.40131 16.8619 3.46523 16.7195C3.52199 16.5931 3.59172 16.4729 3.67332 16.3609C3.76521 16.2348 3.87711 16.1229 4.1009 15.8991L14.4343 5.56569C14.6323 5.36768 14.7313 5.26867 14.8455 5.23158C14.9459 5.19895 15.0541 5.19895 15.1545 5.23158C15.2687 5.26867 15.3677 5.36768 15.5657 5.56569L18.4343 8.43431C18.6323 8.63232 18.7313 8.73133 18.7684 8.84549C18.8011 8.94591 18.8011 9.05409 18.7684 9.15451C18.7313 9.26867 18.6323 9.36768 18.4343 9.56569L8.1009 19.8991C7.87711 20.1229 7.76521 20.2348 7.63908 20.3267C7.52709 20.4083 7.40692 20.478 7.28052 20.5348C7.13815 20.5987 6.98548 20.6403 6.68014 20.7236L2 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> Edit
      </button> */}
      <button
        title="Request Edit Access"
        className="upload-svg"
        onClick={handleShow}
      >
        <UpdatePencilWhite /> Edit Invoice
      </button>



      <Modal show={show} onHide={handleClose} dialogClassName="request-leave" >

        <Modal.Header closeButton>
          <Modal.Title className="modal-title">Update Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />


          <div className='modal-body-padding justify-center'>
            <form className=''>
              <div className='form-flex-wrap'>
                <div className="flex-column">
                  <label className="form-labels">Want to change date? <span className="required">*</span></label>
                  <div className="radio-group">
                    <label>
                      <input
                        type="radio"
                        name="change_date"
                        value="yes"
                        checked={formData.change_date === 'yes'}
                        onChange={handleInputChange}
                      />
                      Change Date
                    </label>
                    <label>
                      <input
                        type="radio"
                        name="change_date"
                        value="no"
                        checked={formData.change_date === 'no'}
                        onChange={handleInputChange}
                      />
                      Workstage
                    </label>
                  </div>
                </div>
                {
                  formData.change_date === 'yes' ? <div className="flex-column">
                    <label className="form-labels">Billing Date <span className="required">*</span></label>
                    <input
                      type="date"
                      name="billing_date"
                      value={formData.billing_date}
                      onChange={handleInputChange}
                      className={`form-input ${errors.billing_date ? 'error' : inputState.billing_date ? 'success' : ''}`}
                    />
                    {errors.billing_date && <span className="error-message">{errors.billing_date}</span>}
                  </div> : <div className=''>
                    {inputFields
                      ?.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()) // Sort by `created_at`
                      ?.map((field, index) => (
                        <div key={index}>
                          <h3 className="dashboard-herosection-left-h4">Stage {index + 1}</h3>
                          <form>
                            <div className='field-cont'>
                              <div className="flex-column">
                                <label className="form-labels">Name:</label>
                                <input
                                  type="text"
                                  name="workStages"
                                  value={field.workStages || ""}
                                  className="form-input-modal form-control-field"
                                  readOnly={field.isSaved} // Make editable if the stage is not saved
                                  onChange={(e) => handleChange(index, e)} // Add onChange handler
                                />
                              </div>
                              <div className="flex-column">
                                <label className="form-labels">Percentage:</label>
                                <input
                                  type="number"
                                  name="percentage"
                                  min={0}
                                  value={field.percentage || ""}
                                  style={{ width: "80px" }}
                                  onChange={(e) => handleChange(index, e)}
                                  className="form-input-modal form-control-field"
                                />
                              </div>
                              <div>
                                {inputFields.length > 1 && !field.invoice_generated && !field.isSaved && (
                                  <button
                                    type="button"
                                    className="remove-stages-button-new"
                                    onClick={() => handleRemoveInputField(index)}
                                  >
                                    Remove
                                  </button>
                                )}
                              </div>
                            </div>
                          </form>
                        </div>
                      ))}
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <div className='justify-center'>


                    </div>
                  </div>
                }

              </div>

              <div className="button-models">
                <button onClick={handleSubmit} className="model-button model-button-leave font-size-heading font-weight500" disabled={loading}>Update</button>
              </div>
            </form>
          </div>

        </Modal.Body>

      </Modal>

    </>
  );
};


const UpdateInvoiceStage = ({ invoiceId, projectDetailsId, workstages, getInvoice }) => {
  const [totalPercentage, setTotalPercentage] = useState(0);
  const [allWorkStages, setAllWorkStages] = useState([]);
  const [inputFields, setInputFields] = useState([{ workStages: '', percentage: '', project_detail: projectDetailsId }]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getClientDetails();
  };

  const getClientDetails = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL_PREBID}/project/workstagesbyprojectDetail/${projectDetailsId}/`);
      setAllWorkStages(res.data)
      const stageNames = typeof workstages === "string"
        ? workstages.split(",").map(stage => stage.trim().toLowerCase())
        : [];
      const filteredStages = res.data.filter(stage =>
        stageNames.includes(stage.workStages.trim().toLowerCase())
      );

      const stagesWithCreatedAt = filteredStages.map(stage => ({
        ...stage,
        created_at: stage.created_at || new Date().toISOString(), // Fallback to current date if missing
        isSaved: true,
      }));

      setInputFields(
        stagesWithCreatedAt.length > 0
          ? stagesWithCreatedAt
          : [{ workStages: '', percentage: '', project_detail: projectDetailsId, isSaved: false, created_at: new Date().toISOString() }]
      );

      let total = 0;
      res.data.forEach(stage => {
        total += stage.percentage || 0;
      });
      setTotalPercentage(total);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveInputField = (index) => {
    const updatedFields = [...inputFields];
    updatedFields.splice(index, 1);
    setInputFields(updatedFields);
    recalculateTotalPercentage(updatedFields);
  };

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedFields = [...inputFields];

    updatedFields[index][name] = value;
    setInputFields(updatedFields);

    const newTotal = recalculateTotalPercentage(updatedFields);

    const lastStage = updatedFields[updatedFields.length - 1];
    const extraStageExists = lastStage.workStages === "" || lastStage.percentage === "";

    if (newTotal < 100 && !extraStageExists && value !== "") {
      setInputFields([...updatedFields, { workStages: '', percentage: '', project_detail: projectDetailsId, isSaved: false, created_at: new Date().toISOString() }]);
    }

    if (newTotal >= 100 && updatedFields.length > 1 && updatedFields[updatedFields.length - 1].percentage === "") {
      const newFields = updatedFields.slice(0, -1);
      setInputFields(newFields);
      recalculateTotalPercentage(newFields);
    }
  };

  const recalculateTotalPercentage = (fields) => {
    let total = 0;
    // fields.forEach(field => {
    //   total += Number(field.percentage || 0);
    // });

    // Add percentages from fields
    fields.forEach(field => {
      total += Number(field.percentage || 0);
    });

    // Add percentages from allWorkStages excluding duplicates
    allWorkStages.forEach(stage => {
      const isDuplicate = fields.some(field => field.workStages === stage.workStages);
      if (!isDuplicate) {
        total += Number(stage.percentage || 0);
      }
    });

    setTotalPercentage(total);
    return total;
  };

  const validatePercentage = () => {
    if (totalPercentage > 100) {
      setErrorMessage(`Total percentage should not be greater than 100. Current value is ${totalPercentage}`);
      return false;
    }
    setErrorMessage("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validatePercentage()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const res = await axios.put(`${BASE_URL_PREBID}/project/invoiceupdateview/${invoiceId}/`, inputFields, {
          headers: {
            'Content-Type': 'application/json',
            accept: "application/json",
          }
        });
        if (res.status === 200) {
          const updatedFields = inputFields.map(field => ({ ...field, isSaved: true }));
          setInputFields(updatedFields);
          await getClientDetails();
          await getInvoice();
          toast.success("Stages updated successfully!");
          handleClose();
        } else {
          toast.error("Error updating stages");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className='text-button' onClick={handleShow}>
        <svg width="20" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 2L22 6M2 22L3.2764 17.3199C3.35968 17.0145 3.40131 16.8619 3.46523 16.7195C3.52199 16.5931 3.59172 16.4729 3.67332 16.3609C3.76521 16.2348 3.87711 16.1229 4.1009 15.8991L14.4343 5.56569C14.6323 5.36768 14.7313 5.26867 14.8455 5.23158C14.9459 5.19895 15.0541 5.19895 15.1545 5.23158C15.2687 5.26867 15.3677 5.36768 15.5657 5.56569L18.4343 8.43431C18.6323 8.63232 18.7313 8.73133 18.7684 8.84549C18.8011 8.94591 18.8011 9.05409 18.7684 9.15451C18.7313 9.26867 18.6323 9.36768 18.4343 9.56569L8.1009 19.8991C7.87711 20.1229 7.76521 20.2348 7.63908 20.3267C7.52709 20.4083 7.40692 20.478 7.28052 20.5348C7.13815 20.5987 6.98548 20.6403 6.68014 20.7236L2 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg> Edit
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="dialog-modal-assign-task-small">
        <Modal.Header closeButton>
          <Modal.Title className="modal-title">Edit Stages</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

          <div className='parent-div'>
            <div className=''>
              {inputFields
                ?.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()) // Sort by `created_at`
                ?.map((field, index) => (
                  <div key={index}>
                    <h3 className="dashboard-herosection-left-h4">Stage {index + 1}</h3>
                    <form>
                      <div className='field-cont'>
                        <div className="flex-column">
                          <label className="form-labels">Name:</label>
                          <input
                            type="text"
                            name="workStages"
                            value={field.workStages || ""}
                            className="form-input-modal form-control-field"
                            readOnly={field.isSaved} // Make editable if the stage is not saved
                            onChange={(e) => handleChange(index, e)} // Add onChange handler
                          />
                        </div>
                        <div className="flex-column">
                          <label className="form-labels">Percentage:</label>
                          <input
                            type="number"
                            name="percentage"
                            min={0}
                            value={field.percentage || ""}
                            style={{ width: "80px" }}
                            onChange={(e) => handleChange(index, e)}
                            className="form-input-modal form-control-field"
                          />
                        </div>
                        <div>
                          {inputFields.length > 1 && !field.invoice_generated && !field.isSaved && (
                            <button
                              type="button"
                              className="remove-stages-button-new"
                              onClick={() => handleRemoveInputField(index)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                ))}
              {errorMessage && <p className="error-message">{errorMessage}</p>}
              <div className='justify-center'>

                <button onClick={handleSubmit} className="model-button model-button-leave font-size-heading font-weight500" disabled={loading}>Update</button>
              </div>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const PerformaInvoice = () => {
  const ref = useRef();
  let { id } = useParams();
  const [invoiceData, setInvoiceData] = useState({
    "project": {},
    "client": {},
    "invoice": {},
  })
  const [reqRaised, SetReqraised] = useState(null);


  const getInvoiceData = async (id) => {
    try {
      const res = await axios.get(`${BASE_URL_PREBID}/project/invoicedetails/${id}/`);
      setInvoiceData(res.data)
      SetReqraised(res?.data?.invoice?.req_raised)
    } catch (err) {
      handleErrorToast(err)
    }
  };


  useEffect(() => {
    getInvoiceData(id);
  }, []);



  return (
    <div>

      {/* <div className='flex-row justify-between'> */}
      <ReactToPrint
        bodyClass="print-agreement"
        content={() => ref.current}
        trigger={() => (
          <button className='model-button model-button-black'>
            <Printer /> Print
          </button>
        )}
      />
      {!invoiceData.invoice?.
        pi_invoice_number
        && reqRaised && (
          <UpdateInvoiceDate i={invoiceData}
            getInvoice={getInvoiceData}
            invoiceId={invoiceData?.invoice?.id}
            projectDetailsId={invoiceData?.project_details?.id}
            workstages={invoiceData.invoice?.work_stages}
          />
        )}
      {!invoiceData.invoice?.invoice_confirmation &&
        <>
          {invoiceData?.invoice?.bill_date_change ?
            // invoiceData?.invoice?.req_raised === "pending" ?
            //   : null
            <>
              <span
                className=""
              >
                Request Status :
              </span>
              <span
                request-status={invoiceData?.invoice?.req_raised}
                className=" request-status form-text-trasformation-uppercase"
              >
                {" "}"{invoiceData?.invoice?.req_raised}"
              </span>
              <span              >
                By : {invoiceData?.invoice?.req_approved_by}
              </span>
            </>
            :

            <EditInvoiceRequest
              id={id}
              getInvoiceData={getInvoiceData}

            />
          }
        </>
      }
      {/* </div> */}

      <PerformaInvoiceSlip ref={ref} />
    </div>
  );
};

export { PerformaInvoice, UpdateInvoiceDate };